exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/dashboard/gender-split-histogram/gender-split-histogram.component.scss
// module id = ../../../../../src/app/pages/dashboard/gender-split-histogram/gender-split-histogram.component.scss
// module chunks = main